<template>
  <div class="video-container">
    <VideoPlayer
      v-if="previewUrl || fullVideoUrl"
      :id="templateId"
      :url="fullVideoUrl"
      :auto-url="previewUrl"
      :autoplay="true"
      :muted="true"
      :object-fit="'contain'"
      :aigc="showAiIcon"
      :poster="coverUrl"
      :start-time="startTime"
      type="template"
      fetchpriority="high"
      @time-update="handleTimeUpdate"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  templateId: number;
  previewUrl?: string;
  fullVideoUrl?: string;
  showAiIcon?: boolean;
  coverUrl?: string;
  startTime?: number;
}>();

const emit = defineEmits<{
  timeUpdate: [time: number];
}>();

const handleTimeUpdate = (time: number) => {
  emit('timeUpdate', time);
};
</script>

<style scoped lang="scss">
.video-container {
  width: calc(100% - 416px);
  aspect-ratio: 16/9;
  border-radius: 12px;
  border: 1px solid var(--x-back-5);
  background-color: var(--x-black-1);
  overflow: hidden;
}
</style>
